import Education from "app/education/page";
import Family from "app/family/page";
import IframeCSS from "app/iframe-test-css/page";
import Mortgage from "app/mortgage/page";
import Home from "app/page";
import Retirement from "app/retirement/page";
import Wealth from "app/wealth/page";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/wealth" element={<Wealth />} />
      <Route path="/family" element={<Family />} />
      <Route path="/retirement" element={<Retirement />} />
      <Route path="/education" element={<Education />} />
      <Route path="/mortgage" element={<Mortgage />} />
      <Route path="/iframe-test-css" element={<IframeCSS />} />
    </Routes>
  );
}

export default App;
